(function () {
  var DAY = 86400000;
  var API = '/api/unstable/graphql.json';
  var CREATE_CART = 'mutation($lines:[CartLineInput!]!,$address:CartAddressInput!){cartCreate(input:{lines:$lines,delivery:{addresses:[{selected:true,address:$address}]}}){cart{id} userErrors{field message}}}';
  var DELIVERY_OPTIONS = 'query($id:ID!){cart(id:$id){id ... @defer{deliveryGroups(first:5,withCarrierRates:true){nodes{selectedDeliveryOption{handle} deliveryOptions{handle deliveryMethodType estimatedCost{amount} deliveryPromise}}}}}}';
  var MONTHS = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'];
  var checkoutDates = {};
  var rebuyList = null;
  var rebuyObserved = false;

  function isWeekend(date) {
    var day = date.getUTCDay();
    return day === 0 || day === 6;
  }

  function addBusinessDays(date, days) {
    while (days > 0) {
      date = new Date(date.getTime() + DAY);
      if (!isWeekend(date)) days--;
    }
    return date;
  }

  function nextBusinessDay(date) {
    do {
      date = new Date(date.getTime() + DAY);
    } while (isWeekend(date));
    return date;
  }

  function storeNow(timeZone) {
    var override = new URLSearchParams(window.location.search).get('delivery_promise_now');
    var match = override && override.match(/^(\d{4})-(\d{2})-(\d{2})(?:T(\d{2}))?/);
    if (match) {
      return { date: new Date(Date.UTC(+match[1], match[2] - 1, +match[3])), hour: +(match[4] || 0) };
    }
    var options = { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', hourCycle: 'h23' };
    var formatter;
    try {
      formatter = new Intl.DateTimeFormat('en-US', Object.assign({ timeZone: timeZone }, options));
    } catch (error) {
      formatter = new Intl.DateTimeFormat('en-US', options);
    }
    var parts = {};
    formatter.formatToParts(new Date()).forEach(function (part) {
      parts[part.type] = +part.value;
    });
    return { date: new Date(Date.UTC(parts.year, parts.month - 1, parts.day)), hour: parts.hour };
  }

  function manualEstimate(el) {
    var now = storeNow(el.dataset.timezone);
    var orderDay = now.date;
    if (isWeekend(orderDay) || now.hour >= +el.dataset.cutoffHour) {
      orderDay = nextBusinessDay(orderDay);
    }
    var shipDay = addBusinessDays(orderDay, +el.dataset.fulfillmentDays);
    var earliest = addBusinessDays(shipDay, +el.dataset.transitMinDays);
    var latest = addBusinessDays(shipDay, +el.dataset.transitMaxDays);
    var dateFormat = new Intl.DateTimeFormat(document.documentElement.lang || undefined, {
      month: 'long',
      day: 'numeric',
      timeZone: 'UTC'
    });
    return earliest.getUTCFullYear() === latest.getUTCFullYear()
      ? dateFormat.formatRange(earliest, latest)
      : dateFormat.format(earliest) + ' – ' + dateFormat.format(latest);
  }

  function parseResponse(text) {
    var result = { data: {}, errors: [] };
    text.split('--graphql').forEach(function (chunk) {
      var start = chunk.indexOf('{');
      if (start < 0) return;
      var part = JSON.parse(chunk.slice(start, chunk.lastIndexOf('}') + 1));
      if (part.errors) result.errors = result.errors.concat(part.errors);
      if (part.data) Object.assign(result.data, part.data);
      (part.incremental || []).forEach(function (increment) {
        if (increment.errors) result.errors = result.errors.concat(increment.errors);
        if (increment.data) result.data.cart = Object.assign(result.data.cart || {}, increment.data);
      });
    });
    if (result.errors.length) throw new Error(result.errors.map(function (error) { return error.message; }).join('; '));
    return result.data;
  }

  function storefront(query, variables) {
    return fetch(API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'multipart/mixed, application/json' },
      body: JSON.stringify({ query: query, variables: variables })
    }).then(function (response) {
      if (!response.ok) throw new Error('Storefront API HTTP ' + response.status);
      return response.text();
    }).then(parseResponse);
  }

  function parsePromise(text) {
    var match = text && text.match(/([A-Za-z]+)\s+(\d{1,2})/g);
    var found = null;
    (match || []).some(function (candidate) {
      var pieces = candidate.split(/\s+/);
      var month = MONTHS.indexOf(pieces[0].toLowerCase());
      if (month < 0) return false;
      var today = new Date();
      var date = new Date(Date.UTC(today.getFullYear(), month, +pieces[1]));
      if (date.getTime() < today.getTime() - 7 * DAY) date = new Date(Date.UTC(today.getFullYear() + 1, month, +pieces[1]));
      found = date;
      return true;
    });
    if (!found) throw new Error('Unreadable delivery promise "' + text + '"');
    return found;
  }

  function fetchCheckoutDate(lines, address) {
    var parts = address.split('|');
    var deliveryAddress = { countryCode: parts[0], zip: parts[2] };
    if (parts[1]) deliveryAddress.provinceCode = parts[1];
    return storefront(CREATE_CART, { lines: JSON.parse(lines), address: { deliveryAddress: deliveryAddress } })
      .then(function (data) {
        var result = data.cartCreate;
        if (result.userErrors.length) throw new Error(result.userErrors.map(function (error) { return error.message; }).join('; '));
        return storefront(DELIVERY_OPTIONS, { id: result.cart.id });
      })
      .then(function (data) {
        var group = data.cart && data.cart.deliveryGroups && data.cart.deliveryGroups.nodes[0];
        if (!group || !group.deliveryOptions.length) throw new Error('No delivery options returned');
        var selected = group.selectedDeliveryOption && group.deliveryOptions.filter(function (option) {
          return option.handle === group.selectedDeliveryOption.handle;
        })[0];
        var option = selected || group.deliveryOptions
          .filter(function (option) { return option.deliveryMethodType === 'SHIPPING' && option.deliveryPromise; })
          .sort(function (a, b) { return a.estimatedCost.amount - b.estimatedCost.amount; })[0];
        if (!option || !option.deliveryPromise) throw new Error('No delivery date on the default option');
        return new Intl.DateTimeFormat(document.documentElement.lang || undefined, {
          weekday: 'long',
          month: 'long',
          day: 'numeric',
          timeZone: 'UTC'
        }).format(parsePromise(option.deliveryPromise));
      });
  }

  function fill(el) {
    if (!el.dataset.address) {
      el.textContent = el.dataset.text.replace('__DATE__', manualEstimate(el));
      return Promise.resolve();
    }
    var key = el.dataset.lines + el.dataset.address;
    checkoutDates[key] = checkoutDates[key] || fetchCheckoutDate(el.dataset.lines, el.dataset.address);
    return checkoutDates[key].then(function (formatted) {
      el.textContent = el.dataset.text.replace('__DATE__', formatted);
    }).catch(function (error) {
      console.error('[delivery-promise]', error);
      el.textContent = el.dataset.text.replace('__DATE__', manualEstimate(el));
    });
  }

  function render() {
    document.querySelectorAll('[data-delivery-promise]').forEach(fill);
  }

  function placeRebuyList() {
    var footer = document.querySelector('#rebuy-cart [data-rebuy-cart-anchor="footer"]');
    if (!footer || !rebuyList || footer.contains(rebuyList)) return;
    var subtotal = footer.querySelector('[data-rebuy-component="cart-subtotal"]');
    if (subtotal) {
      subtotal.parentNode.insertBefore(rebuyList, subtotal);
    } else {
      footer.insertBefore(rebuyList, footer.firstChild);
    }
  }

  function syncRebuy() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + '?section_id=delivery-promise-cart')
      .then(function (response) {
        if (!response.ok) throw new Error('Section rendering HTTP ' + response.status);
        return response.text();
      })
      .then(function (html) {
        var list = new DOMParser().parseFromString(html, 'text/html').querySelector('.c-delivery-promise-list');
        list = list ? document.importNode(list, true) : null;
        var ready = list ? Array.prototype.map.call(list.querySelectorAll('[data-delivery-promise]'), fill) : [];
        return Promise.all(ready).then(function () {
          if (rebuyList) rebuyList.remove();
          rebuyList = list;
          placeRebuyList();
        });
      })
      .then(function () {
        var cart = document.getElementById('rebuy-cart');
        if (cart && !rebuyObserved) {
          new MutationObserver(placeRebuyList).observe(cart, { childList: true, subtree: true });
          rebuyObserved = true;
        }
      })
      .catch(function (error) {
        console.error('[delivery-promise]', error);
      });
  }

  render();
  window.addEventListener('countdown', render);
  window.addEventListener('listCart', render);
  ['rebuy:smartcart.ready', 'rebuy:smartcart.show', 'rebuy:cart.change'].forEach(function (name) {
    document.addEventListener(name, syncRebuy);
  });
})();
